import { Facture, PaymentStatus, TPayment, ArtizenUserClass } from '@Arti-zen/package-backoffice'
import { DateTime } from 'luxon'

export enum EPaymentProgressStatus {
  paid = 'paid',
  inProgress = 'in progress',
  subscription_waiting = 'subscription waiting',
  partialSup = 'paid more',
  partialLess = 'paid less',
  moreThanOne = 'more than one payment',
  unpaid = 'unpaid',
  error_mandat = 'error mandat',
  error_rate_limit = 'error rate limit',
  unknown = 'no payment linked',
  refreshing = 'resfreshing',
  refreshError = 'refresh error',
  error = 'error',
}

export const PaymentProgressTranslate = {
  [PaymentStatus.CREATED]: EPaymentProgressStatus.inProgress,
  [PaymentStatus.PENDING_CUSTOMER_APPROVAL]: EPaymentProgressStatus.inProgress,
  [PaymentStatus.PENDING_SUBMISSION]: EPaymentProgressStatus.inProgress,
  [PaymentStatus.SUBMITTED]: EPaymentProgressStatus.inProgress,
  [PaymentStatus.CONFIRMED]: EPaymentProgressStatus.paid,
  [PaymentStatus.PAID_OUT]: EPaymentProgressStatus.paid,
  [PaymentStatus.CANCELLED]: EPaymentProgressStatus.unpaid,
  [PaymentStatus.CHARGED_BACK]: EPaymentProgressStatus.unpaid,
  [PaymentStatus.CUSTOMER_APPROVAL_DENIED]: EPaymentProgressStatus.unpaid,
  [PaymentStatus.FAILED]: EPaymentProgressStatus.unpaid,
  [PaymentStatus.MANUAL]: EPaymentProgressStatus.paid,
}

export type FactureExtended = Facture & {
  paymentProgress: EPaymentProgressStatus
}

export interface IFacturationListState {
  dateStart: DateTime
  dateEnd: DateTime
  isRefreshing?: boolean
  stateList: Facture['state'][]
  errorList: Facture['errorState'][]
  deactivatedClient: boolean
  activatedClient: boolean
  paymentStatusList: EPaymentProgressStatus[]
  factures: FactureExtended[]
  factureMissingList: TFactureMissing[]
  displayedFactures: FactureExtended[]
  paymentOrphanList: TPaymentExtended[]
  search?: string
  searchMissing?: string
}

export type TFactureMissing = {
  id: ArtizenUserClass['id']
  user: ArtizenUserClass
  subscriptionDate: DateTime
  resilisationDate: DateTime
  nbFactureTheo: number
  nbFactureReal: number
  diff: number
  factureTheoList: string[]
  factRealList: string[]
}

export type TPaymentExtended = TPayment & {
  artisan: ArtizenUserClass
  paymentProgress: EPaymentProgressStatus
  chargeDateTime: DateTime
}
